import React from 'react';
import { Helmet } from 'react-helmet-async';

import ARProjectplanDashboard from '../app-rationalization/ARProjectPlan/ARProjectplanDashboard';

const ProjectPlan = () => (
  <>
    <Helmet>
      <title> Dashboard: Project Plan</title>
    </Helmet>

    <ARProjectplanDashboard />
  </>
);

export default ProjectPlan;
